import { render, staticRenderFns } from "./TaskPhotosGallery.vue?vue&type=template&id=f82cdc70"
import script from "./TaskPhotosGallery.vue?vue&type=script&lang=js"
export * from "./TaskPhotosGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports